module.exports = __webpack_public_path__ + "static/media/cnito-sizzle-pt.47512190.mp4";